import httpService from './http.service';
const getManufacturingLocation = async (manufacturingDivision, configModel) => {
  let location;
  try {
    let response = await httpService.getAll(
      `/ManufacturingLocation/GetManufacturingLocation?manufacturingDivision=${manufacturingDivision}&configModel=${configModel}`
    );
    location = response.data
      ? response.data.toString().trim()
      : manufacturingDivision;
  } catch (error) {
    console.log(error);
  }

  return location;
};

export { getManufacturingLocation };
